import { MouseEvent, useCallback, useRef } from 'react';
import type { UsePreventDoubleClick } from './usePreventDoubleClick.types';

export const DELAY_BETWEEN_CLICKS = 1000;

export const usePreventDoubleClick = (): UsePreventDoubleClick => {
  const clickTimestampRef = useRef<number>();

  const setClickTimeStamp = useCallback((event: MouseEvent) => {
    clickTimestampRef.current = event.timeStamp;
  }, []);

  const isAnotherMouseActionAllowed = useCallback(
    (event: MouseEvent) =>
      !clickTimestampRef.current || event.timeStamp - clickTimestampRef.current > DELAY_BETWEEN_CLICKS,
    [],
  );

  return {
    setClickTimeStamp,
    isAnotherMouseActionAllowed,
  };
};
